// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_ey-0";
export var fileCarousel = "_ey-2";
export var removeFileButton = "_ey-1";